// React
import React, {Component} from 'react';
// Styles
import './styles.scss';
// Material
import {Modal} from '@material-ui/core';
// Components
import {Button} from '@components/Input';
// Svg
import {deleteSvg} from "@assets";

export class Conditional extends Component {
    render() {
        const {t, open, handleClose, handleAction, type} = this.props;
        return (
            <Modal
                open={open}
                onClose={handleClose}
            >
                <div className={"conditional_main"}>
                    <div className={"conditional_content"}>
                        <span>{deleteSvg()}</span>
                        <span>{t(`commons:modals.conditional.${type}.title`)}</span>
                    </div>
                    <span>{t(`commons:modals.conditional.${type}.description`)}</span>
                    <div className={"conditional_actions"}>
                        <div>
                            <Button type={"primary"} onClick={() => handleClose()} text={t('commons:modals.conditional.actions.cancel')} />
                            <Button type={"normal_delete"} onClick={handleAction} text={t('commons:modals.conditional.actions.confirm')} />
                        </div>
                    </div>
                </div>
            </Modal>
        );
    }
}
